import type { FC } from 'react'
import { ImageCarousel, ImageCarouselProps } from '@wiggui/ds/ImageCarousel'
import 'swiper/css/bundle'

export const SwiperImages: FC<ImageCarouselProps> = ({ ...props }) => {
  return <ImageCarousel {...props} />
}
